define('StellarGrade.ST_Product.Main', [
    'StellarGrade.ST_Product.ProductDetails.Information.View',
    'StellarGrade.ST_Product.ItemDetails.Model.Specifications',
    'StellarGrade.ST_Product.ProductViews.Price.View'
], function (
    ProductDetailsInformationView,
    ItemDetailsSpecificationsModel,
    ProductViewsPriceView
) {
    'use strict';

    return {
        mountToApp: function(container) {
            ProductDetailsInformationView.loadModule(container);
            ItemDetailsSpecificationsModel.loadModule(container);
            ProductViewsPriceView.loadModule(container);
        }
    }
})
